import { ButtonIcon } from './ButtonIcon';
import { ButtonRoot } from './ButtonRoot';

export const Button = {
  Root: ButtonRoot,
  Icon: ButtonIcon,
};
